import React, { useEffect, useState } from "react";
import "./style.scss";
import copyIcon from "../../../assets/icons/copy-green.svg";
import { useSelector } from "react-redux";
import { getAffiliateList } from "../../../utils/apis/payments";
import toast from "react-hot-toast";
import CopyToClipboard from "react-copy-to-clipboard";
import { Pagination } from "@mui/material";
import LoaderOverlay from "../../../reusableComponents/LoaderOverlay/Index";
function FinancialTransactions() {
  const [codeList, setCodeList] = useState({});
  const { idToken } = useSelector((state) => state.auth);
  const [isLoading, setIsLoading] = useState(false);
  const [params, setParams] = useState({
    page: 1,
    page_size: 9,
  });
  const fetchAffiliateList = async () => {
    setIsLoading(true);
    try {
      const response = await getAffiliateList(idToken, params);
      setCodeList(response?.data || []);
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    fetchAffiliateList();
  }, [JSON.stringify(params)]);

  return (
    <>
      {isLoading && <LoaderOverlay />}
      <div className="financial-transactions box">
        <div className="ft-header">
          <h2 className="component-heading">
            Financial Performance/Transaction
          </h2>
          <span>Show More</span>
        </div>
        <div className="ft-box-wrapper">
          {codeList?.results?.data?.map((box, index) => (
            <FtBox key={index} codeInfo={box} />
          ))}
        </div>
      </div>
      {Math.ceil(codeList?.count / params.page_size) > 1 && (
        <div className="pagination-container">
          <Pagination
            count={Math.ceil(codeList?.count / params.page_size)}
            page={params.page}
            onChange={(e, page) => {
              setParams((prevParams) => ({ ...prevParams, page }));
            }}
            size="small"
            showFirstButton
            showLastButton
            shape="rounded"
            className="pagination"
          />
        </div>
      )}
    </>
  );
}

export default FinancialTransactions;

const FtBox = ({ codeInfo }) => {
  const truncateString = (inputString, maxLength) => {
    const formattedString = inputString.toString();
    if (formattedString.length > maxLength) {
      return inputString.toString().substring(0, maxLength) + "...";
    }
    return inputString;
  };
  const handleCopyToClipboard = (text) => {
    toast.success("Text copied to clipboard!", {
      position: "top-right",
      autoClose: 2000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      theme: "dark",
      className: "custom-toast-container",
    });
  };

  return (
    <div className="ft-box">
      <div className="ft-box-items">
        <p className="title">Code</p>
        <span className="value">{codeInfo.code}</span>
      </div>
      <div className="ft-box-items">
        <p className="title">Url</p>
        <span style={{ fontSize: "12px" }} className="value">
          {truncateString(codeInfo.url, 12)}{" "}
          <CopyToClipboard text={codeInfo.url} onCopy={handleCopyToClipboard}>
            <p className="table_copy_button" style={{ cursor: "pointer" }}>
              <img src={copyIcon} alt="" />
            </p>
          </CopyToClipboard>
        </span>
      </div>
      <div className="ft-box-items">
        <p className="title">Commission %</p>
        <span className="value">{codeInfo.percentage}</span>
      </div>
      <div className="ft-box-items">
        <p className="title">Pushed Leads</p>
        <span className="value">{codeInfo.pushed_leads}</span>
      </div>
      <div className="ft-box-items">
        <p className="title">Used By</p>
        <span className="value">{codeInfo.consumed_by_count}</span>
      </div>
    </div>
  );
};
